export const API_URL ='https://api.vnextit.in';

// export const API_URL ='http://localhost:3001';

// let token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NzFiNjRmY2EzODQ4N2Q2NmNjNDI2NTIiLCJpYXQiOjE3Mjk4NDkyMDMsImV4cCI6MTczMDQ1NDAwM30.6e0_Z0uA82V8rJrcO3D6beWxR-8B5eeVPRUrdlBv9Qo"